import React, { useContext, useEffect, useRef, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import Row, { RowBetween } from '../../Row'
import { AutoColumn } from '../../Column'
import { ChevronDown as Arrow } from 'react-feather'
import { TYPE } from '../../../theme'
import { StyledIcon } from '..'

const Wrapper = styled.div`
    z-index: 20;
    position: relative;
    background-image: linear-gradient(to bottom, #11314a, #0c2539);
    border: 1px solid ${({open, color}) => (open ? color : '#224765')}
    max-width: 150px;
    width: 100%;
    padding: 6px 10px;
    padding-right: 6px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    :hover {
        cursor: pointer;
    }
`

const Dropdown = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  padding-top: 40px;
  background-color: ${({ theme }) => theme.bg2};
  border: 1px solid #224765;
  padding: 10px 10px;
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-size: 1rem;
  color: black;
  :hover {
    cursor: pointer;
  }
`

const ArrowStyled = styled(Arrow)`
  height: 20px;
  width: 20px;
`

export const ExtStyledIcon = styled(StyledIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
`

const DropdownSelect = ({ options, active, setActive, color }) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const theme = useContext(ThemeContext)
  const wrapperRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Wrapper ref={wrapperRef} open={showDropdown} color={color}>
      <RowBetween onClick={() => setShowDropdown(!showDropdown)} justify="center">
        <TYPE.main color={theme.text1}>{active}</TYPE.main>
        <ExtStyledIcon>
          <ArrowStyled />
        </ExtStyledIcon>
      </RowBetween>
      {showDropdown && (
        <Dropdown>
          <AutoColumn gap="20px">
            {Object.keys(options).map((key, index) => {
              let option = options[key]
              return (
                option !== active && (
                  <Row
                    onClick={() => {
                      setShowDropdown(false)
                      setActive(option)
                    }}
                    key={index}
                  >
                    <TYPE.body fontSize={14}>{option}</TYPE.body>
                  </Row>
                )
              )
            })}
          </AutoColumn>
        </Dropdown>
      )}
    </Wrapper>
  )
}

export default DropdownSelect
